import React, { useCallback, useState } from 'react'
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import useDarkSide from '../hooks/useDarkMode'
function Switcher() {
    const [colorTheme, setTheme] = useDarkSide();
    const [darkSide, setDarkSide] = useState(
      colorTheme === "light" ? true : false
    );
  
    const toggleDarkMode = useCallback((checked) => {
      setTheme(colorTheme);
      setDarkSide(checked);
    },[colorTheme]);
    return (
        <div>
            <DarkModeSwitch 
            className="hover:scale-105 transition-all duration-200 "
            moonColor="#00789A"
            sunColor="#00C9FF"
            style={{ marginBottom: "0" }}
            checked={darkSide}
            onChange={toggleDarkMode}
            size={24}
            />
        </div>
    )
}

export default Switcher
